import React from 'react';
import { IconProps } from './types';
export const ClearIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      className={`ClearIcon ${className}`}
    >
      <title>{title}</title>
      <path d="M16.27,15,24,7.3a1,1,0,1,0-1.41-1.41l-7.7,7.7-7.7-7.7A1,1,0,0,0,5.74,7.3l7.7,7.7-7.7,7.7a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l7.7-7.7,7.7,7.7a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41Z" />
    </svg>
  );
};
